import React from 'react';
import colorForAttitude from 'util/colorForAttitude';
import styled from 'styled-components';
import { GetCaseQuery } from '__generated__/graphql';
import { CaseLink } from 'features/link-helpers/CaseLink';

export interface CitingCasesLinkProps {
  case: NonNullable<GetCaseQuery['case']>;
}

export const CitingCasesLink = ({
  case: { judicataId, citationCount = 0, treatmentAttitudeName },
}: CitingCasesLinkProps) => {
  const color = colorForAttitude(treatmentAttitudeName);
  return (
    <StyledCitatorLink
      citator
      judicataId={judicataId!}
      className="citator-link"
      $color={color}
    >
      {citationCount} citing cases
    </StyledCitatorLink>
  );
};

const StyledCitatorLink = styled(CaseLink)<{ $color: string }>`
  color: ${({ $color }) => $color};
  display: block;
  font-family: 'Zilla Slab', serif;
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 8px;
  padding: 4px 0 0 4px;
  white-space: nowrap;
`;
